export default __webpack_public_path__ + "8cd154a12c2c455152bc55a30ade6931.jpg";